import { createShell } from '../../shell/createShell';
import { route as altIntroRoute } from './pages/alt_intro';
import { route as altHubRoute } from './pages/alt_hub';
import { route as altSearchRoute } from './pages/alt_search';
import { route as altRefundRoute } from './pages/alt_refund';
import { route as altContactRoute } from './pages/alt_contact';
import { route as altConfirmationRoute } from './pages/alt_confirmation';
import { route as altResultsRoute } from './pages/alt_results';
import { route as altDetailsRoute } from './pages/alt_details';
import { route as altSummaryRoute } from './pages/alt_summary';
import { route as altMobileCalendarRoute } from './pages/alt_calendar';
import { AlternativesFunnel } from '.';
const routes = [altIntroRoute, altHubRoute, altSearchRoute, altRefundRoute, altContactRoute, altConfirmationRoute, altResultsRoute, altDetailsRoute, altSummaryRoute, altMobileCalendarRoute];
export const alternativesShell = createShell(AlternativesFunnel, {
  options: {
    routes,
    namespace: 'alternatives_shell'
  }
});